import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";
import InputMask from 'react-input-mask';
import * as styles from "./style.css";

import Icon from '../../../../icons/Icon';
import StickersComponentsScannerHeader from '../../components/scanner-header';
import Div100vh from "../../../../uq-ui/components/div-100";
import UQButton from "../../../../uq-ui/components/button";

const exampleImg = require("./img/example.png");

class QRCodeEnter extends PureComponent {
  static defaultProps = {
    goBack: () => {},
    onQREntered: () => {}
  };

  static propTypes = {
    goBack: PropTypes.func.isRequired,
    onQREntered: PropTypes.func.isRequired,
    error: PropTypes.object,
    resetErrors: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      code: '',
      aggregate: '',
      inputError: false,
    };
  }

  onBackPressed = () => {
    this.props.goBack();
  }

  onNextPressed = () => {
    const { code } = this.state;
    if (code.length === 12) {
      this.props.onQREntered(code);
    }
  }

  onChange = (event) => {
    if (this.props.error || this.state.inputError) {
      this.props.resetErrors();
    }
    this.setState({ code: event.target.value });
  }

  render() {
    const { code, inputError } = this.state;
    return (
      <Fragment>
        <StickersComponentsScannerHeader theme="brand" title={this.props.t('headerTitle')}/>
        <Div100vh className={styles.container}>
          <div className={`${styles.title} font-title`}>{this.props.t('title')}</div>
          <InputMask mask="************" 
                     onChange={this.onChange} 
                     value={code}
                     maskPlaceholder="-">
            <input className={styles.textInput}
                   placeholder={this.props.t('placeholder')}/>
          </InputMask>
          <div className={styles.inputErrorContainer}>
            {(inputError || this.props.error) && 
              <div className={styles.inputError} style={{ position: 'absolute' }}>
                <Icon name="InputError" style={{ width: 21, height: 21, marginRight: 5 }}/> 
                <div className={`${styles.inputErrorText} font-text`}>{this.props.t('error')}</div>
              </div>}
          </div>
          
          <img src={exampleImg} className={styles.exampleImg} />
          <div className={styles.controlsContainer}>
            <UQButton label={this.props.t('backBtn')}
                      containerClass={styles.backBtn}
                      containerStyle={{ minWidth: 140 }}
                      theme={'whiteBrand'} 
                      onPress={this.onBackPressed}/>
            <UQButton label={this.props.t('nextBtn')}
                      containerStyle={{ minWidth: 140 }}
                      theme={'brand'}
                      notPressOpacity={true}
                      onPress={this.onNextPressed}/>
          </div>
        </Div100vh>
      </Fragment>
    );
  }
}
export default withTranslation('cmp-code-enter')(QRCodeEnter);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/enter-code/index.jsx